<template>
    <div class="com-container">
        <div class="com-chart" ref="realTIme_ref"></div>
    </div>
</template>
<script>
import Vue from 'vue'
export default {
    data() {
        return {
            chartInstance: null,
            yDatearr1: [25,15,16,19,26,15,16,19,18,25],
            yDatearr2: [16,15,16,19,19,15,15,16,19,26],
            yDatearr3: [15,16,19,25,15,16,19,26,16,20],
            yDatearr4: [5,6,8,9,9,10,9,11,10,12],
            fruit: ['07:00:00','07:05:00','07:10:00','07:15:00','07:20:00','07:25:00','07:30:00','07:35:00','07:40:00','07:45:00'],
            timerId: null,
        };
    },
    mounted() {
        this.initChart();
        this.startInterver();
        this.getData()
        window.addEventListener("resize", this.screenAdapter);
        this.screenAdapter()
    },
    destroyed() {
        clearInterval(this.timerId)
        window.removeEventListener("resize", this.screenAdapter);
    },
    methods: {
        initChart() {
            this.chartInstance = this.$echarts.init(this.$refs.realTIme_ref, "dark");
            const initOption = {
                title: {
                    text: " ▎病房温度分析",
                    left: 20,
                    top: 20,
                },
                grid: {
                    top: "35%",
                    left: "3%",
                    right: "4%",
                    bottom: "5%",
                    containLabel: true, // 包含坐标轴上的文字
                },
                tooltip: {
                    trigger: "axis",
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    borderWidth: '0.1',
                    textStyle: {
                        color: 'black'
                    },
                    position: function (pt) {
                        return [pt[0], "20%"];
                    },
                    valueFormatter: function (value) {
                        return value + '℃'
                    }
                },
                legend: {
                    left: 40,
                    top: '20%',
                    icon: 'circle'
                },
                dataZoom: [
                    {
                        //区域缩放
                        type: "inside", //slider滑块，inside鼠标滑轮或双指缩放
                        xAxisIndex: 0, //xy轴筛选
                    },
                    {
                        start: 0, //缩放开始百分比
                        end: 100, //缩放结束百分比
                    },
                ],
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                },
                yAxis: {
                    type: "value",
                    max: 60,
                    min:-10,
                    boundaryGap: [0, "100%"],
                    axisLine: {
                        show: true, //展示y轴线
                    },
                    axisLabel: {
                        formatter: "{value} °C",
                    },
                },
                series: [
                    {
                        name: "病房楼",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        sampling: "lttb",
                        markPoint: {
                            data: [
                                { type: "max", name: "Max" },
                                { type: "min", name: "Min" },
                            ],
                        },
                        itemStyle: {
                            //color: "rgb(255, 70, 131)",
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: "rgb(255, 158, 68,0.5)",
                                },
                                {
                                    offset: 1,
                                    color: "rgb(255, 70, 131,0)",
                                },
                            ]),
                        },
                    },
                    {
                        name: "综合楼",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        sampling: "lttb",
                        markPoint: {
                            data: [
                                { type: "max", name: "Max" },
                                { type: "min", name: "Min" },
                            ],
                        },
                        itemStyle: {
                            //color: "rgb(255, 70, 131)",
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: "rgb(255, 158, 68,0.5)",
                                },
                                {
                                    offset: 1,
                                    color: "rgb(255, 70, 131,0)",
                                },
                            ]),
                        },
                    },
                    {
                        name: "门诊楼",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        sampling: "lttb",
                        markPoint: {
                            data: [
                                { type: "max", name: "Max" },
                                { type: "min", name: "Min" },
                            ],
                        },
                        itemStyle: {
                            //color: "rgb(255, 70, 131)",
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: "rgb(255, 158, 68,0.5)",
                                },
                                {
                                    offset: 1,
                                    color: "rgb(255, 70, 131,0)",
                                },
                            ]),
                        },
                    },
                    {
                        name: "室外温度",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        sampling: "lttb",
                        markPoint: {
                            data: [
                                { type: "max", name: "Max" },
                                { type: "min", name: "Min" },
                            ],
                        },
                        itemStyle: {
                            //color: "rgb(255, 70, 131)",
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: "rgb(255, 158, 68,0.5)",
                                },
                                {
                                    offset: 1,
                                    color: "rgb(255, 70, 131,0)",
                                },
                            ]),
                        },
                    },
                ],
            };
            this.chartInstance.setOption(initOption);
        },
        // 定时器
        startInterver() {
            // 预先判断定时器是否清除，存在消除1
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            this.timerId = setInterval(() => {
                const now = new Date();
                const hours = ("0" + now.getHours()).slice(-2);
                const minutes = ("0" + now.getMinutes()).slice(-2);
                const seconds = ("0" + now.getSeconds()).slice(-2);
                var time = hours + ":" + minutes + ":" + seconds;
                this.fruit.push(time);
                this.yDatearr1.push(+(Math.floor(Math.random() * (25 - 15 + 1)) + 15));
                this.yDatearr2.push(+(Math.floor(Math.random() * (25 - 15 + 1)) + 15));
                this.yDatearr3.push(+(Math.floor(Math.random() * (25 - 15 + 1)) + 15));
                this.yDatearr4.push(+(this.$globalConfig.data));
                // this.yDatearr3.push(+(Math.random() * 60).toFixed(2));
                this.updateChart()
            }, 300000);
        },
        // 请求数据，未调用
        async getData() {
            // const ret = await this.$http.get('')
            // this.allData = ret
            const now = new Date();
            const year = now.getFullYear();
            const month = ("0" + (now.getMonth() + 1)).slice(-2);
            const day = ("0" + now.getDate()).slice(-2);
            const hours = ("0" + now.getHours()).slice(-2);
            const minutes = ("0" + now.getMinutes()).slice(-2);
            const seconds = ("0" + now.getSeconds()).slice(-2);
            const formattedTime = year + month + day + hours + minutes + seconds;
            var time = hours + ":" + minutes + ":" + seconds;
            this.fruit.push(time);
            this.yDatearr1.push(+(Math.floor(Math.random() * (25 - 15 + 1)) + 15));
                this.yDatearr2.push(+(Math.floor(Math.random() * (25 - 15 + 1)) + 15));
                this.yDatearr3.push(+(Math.floor(Math.random() * (25 - 15 + 1)) + 15));
                this.yDatearr4.push(+(this.$globalConfig.data));
                
            this.updateChart()
        },
        updateChart() {
            const dataOption = {
                xAxis: {
                    data: this.fruit,
                },
                series: [
                    {
                        data: this.yDatearr1,
                    },
                    {
                        data: this.yDatearr2,
                    },
                    {
                        data: this.yDatearr3,
                    },
                    {
                        data: this.yDatearr4,
                    },
                ],
            }
            this.chartInstance.setOption(dataOption)
            
        },
        screenAdapter() {
            const titleFontSize = (this.$refs.realTIme_ref.offsetWidth / 100) * 3.6;
            const adapterOption = {
                title: {
                    textStyle: {
                        fontSize: titleFontSize/1.4,
                    },
                },
                legend: {
                    itemWidth: titleFontSize/2,
                    itemHeight: titleFontSize/2,
                    itemGap: titleFontSize/2, //图例间距
                    textStyle: {
                        fontSize: titleFontSize/2
                    }
                }
            }
            this.chartInstance.setOption(adapterOption)
            this.chartInstance.resize()
        },
    }
};
</script>
<style lang="less" scoped>
// .title {
//     position: absolute;
//     left: 20px;
//     top: 20px;
//     z-index: 10;
//     color: white;
// }</style>